import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { BreadcrumbsService } from 'src/app/services/utils/breadcrumbs.service';

@Component({
  selector: 'app-search-orders',
  templateUrl: './search-orders.component.html',
  styleUrls: ['./search-orders.component.css']
})
export class SearchOrdersComponent implements OnInit {

  title = 'Órdenes';
  subtitle = 'Permite buscar cualquier orden en el gestor';

  constructor(private router: Router, private breadcrumbsService: BreadcrumbsService,
              private titleService: Title) {
  }

  ngOnInit() {
    if (this.titleService.getTitle().includes(" - ")) {
      this.titleService.setTitle(this.titleService.getTitle().split(" - ")[1]);
    }
    this.breadcrumbsService.sendBreadcrumbs({ breadcrumbs: [{ title: 'Órdenes', url: 'provision/orders/search' }] });
  }

}
